module.exports = __webpack_public_path__ + "ee.10148440.svg";